//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ConfirmationDialog',
  props: {
    isFileImporting: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    opened: false,
    resolve: null,
    reject: null,
    message: '',
    title: '',
  }),

  methods: {
    confirm(title, message) {
      this.opened = true
      this.title = title;
      this.message = message;
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.resolve(true)
      this.opened = false
    },
    cancel() {
      this.resolve(false)
      this.opened = false
    }
  }
}
